// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"19":"header","922":"edit"}[chunkId] + "." + {"19":"f33a68ed","922":"c6b29e01"}[chunkId] + ".css";
};